export default {

    data: function () {
        return {
        };
    },

    methods: {
        getIngressImageSrc: function (item, imageAttrs) {
            return this.$helpers.getIngressImageSrc(item, imageAttrs);
        },

        /**
         * Ingress image upload url
         */
        getIngressImageUploadUrl: function (item, resource) {
            return item && this.$helpers.getBaseUrl() +
                `/svc/${resource}/${item.Id}/images/ingressimage`;
        },

        getCoverImageSrc: function (item, imageAttrs) {
            return this.$helpers.getCoverImageSrc(item, imageAttrs);
        },

        /**
         * Cover image upload url
         */
        getCoverImageUploadUrl: function (item, resource) {
            return item && this.$helpers.getBaseUrl() +
                `/svc/${resource}/${item.Id}/images/coverimage`;
        },

        /**
         * Page image banner style
         */
        getImageBannerStyle: function (item, doEdit, useIngressImage, minHeight, imageAttrs) {
            return this.$helpers.getBannerImageStyle(item, doEdit, useIngressImage, minHeight, imageAttrs);
        }
    }
};
